// Taille de page de la liste /admin/reservations (pagination côté serveur).
export const TRIP_RESERVATIONS_PAGE_SIZE = 10;

// Statuts acceptés par QR_LIST_TRIP_RESERVATION : TripReservationStatusEnum du
// controller (ce sont les statuts réellement définis dans le domaine). Un statut
// absent de cette liste n'est jamais envoyé au serveur.
export const TRIP_RESERVATION_STATUS_FILTERS = [
  "CONFIRMED",
  "CREATED",
  "IN_PROGRESS",
  "CANCELED",
  "ARCHIVED",
  "PASSED",
];

/**
 * Variables de QR_LIST_TRIP_RESERVATION : seul point de construction des
 * paramètres de la liste. `search` est déjà passé par useDebouncedSearch (seuil
 * et délai appliqués en amont) ; `status` n'existe dans l'objet que lorsqu'il
 * doit être envoyé (« Tous » n'envoie pas de statut).
 */
export const buildTripReservationsListVariables = ({
  currentPage = 0,
  search,
  status,
  establishmentIds,
}) => {
  const variables = {
    paginationParams: { currentPage, sizePage: TRIP_RESERVATIONS_PAGE_SIZE },
    establishmentIds,
  };
  if (search) variables.search = search;
  if (TRIP_RESERVATION_STATUS_FILTERS.includes(status)) variables.status = status;
  return variables;
};
